//--------------------------------------------------------------------------------------------------
//# Imports

import React, { useEffect, useMemo, useRef, useState } from "react";
import "./background.css";

import background_1920px from "../../image/backgrounds/background_1920px_WEBP.webp";
import background_1400px from "../../image/backgrounds/background_1400px_WEBP.webp";
import background_1080px from "../../image/backgrounds/background_1080px_WEBP.webp";
import background_640px from "../../image/backgrounds/background_640px_WEBP.webp";









//--------------------------------------------------------------------------------------------------
//# Functions

function pickBackgroundSrc(width) {
  if (width > 1400) return background_1920px;
  if (width > 1080) return background_1400px;
  if (width > 640) return background_1080px;
  return background_640px;
}

export default function Background({ strength = -0.52 }) {
  const layer_reference = useRef(null);

  const [vw, setVw] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth : 1920
  );

  const src = useMemo(() => pickBackgroundSrc(vw), [vw]);

  useEffect(() => {
    const onResize = () => setVw(window.innerWidth);
    window.addEventListener("resize", onResize, { passive: true });
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    const layer = layer_reference.current;
    if (!layer) return;

    const prefersReducedMotion =
      typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (prefersReducedMotion) {
      layer.style.transform = "translate3d(0, 0, 0)";
      return;
    };

    let ticking = false;

    const update = () => {
      ticking = false;
      const y = window.scrollY || 0;
      layer.style.transform = `translate3d(0, ${y * strength}px, 0)`;
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    update();

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [strength]);










//--------------------------------------------------------------------------------------------------
//# HTML

  return (
    <div className="background" aria-hidden="true">
      <div className="backgroundLayer" ref={layer_reference}>
        <img className="backgroundImage" src={src} alt="" draggable="false" />
      </div>
    </div>
  );
}
